<template>
  <div class="centerIntro-wrap">
    <div class="centerIntro-content">
      <Breadcrumb :options="crumbOptions"></Breadcrumb>
      <div class="title">{{ dataList.title }}</div>
      <!-- <div class="summary">
        <span>新闻速递</span><span>李老师</span><span>2021</span>
      </div> -->
      <div class="content" v-html="dataList.detail"></div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb'
import { getResolveCrumb } from '@/utils/crumb.js'
import { policyList, newList } from '../configs/config'

export default {
  data() {
    return {
      policyList,
      newList,
      crumbOptions: [],
      dataList: {}
    }
  },
  components: {
    Breadcrumb
  },
  created() {
    const { id, name } = this.$route.query
    if (name === '政策法规') {
      this.dataList = this.policyList[id - 1]
    } else {
      this.dataList = this.newList[id - 1]
    }
    this.settingCrumb()
  },
  methods: {
    settingCrumb() {
      const { path, query: { name } } = this.$route
      const crumbOptions = getResolveCrumb(path, name)
      this.crumbOptions = crumbOptions
    }
  }

}
</script>
